import{ToastProvider}from"@jutro/components";export const useToastIntegration=()=>({toast:ToastProvider.toast});